import { render, staticRenderFns } from "./AlertMappingForm.vue?vue&type=template&id=3cc18eda&scoped=true&"
import script from "./AlertMappingForm.vue?vue&type=script&lang=js&"
export * from "./AlertMappingForm.vue?vue&type=script&lang=js&"
import style0 from "./AlertMappingForm.vue?vue&type=style&index=0&id=3cc18eda&prod&lang=css&"
import style1 from "./AlertMappingForm.vue?vue&type=style&index=1&id=3cc18eda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc18eda",
  null
  
)

/* custom blocks */
import block0 from "./AlertMappingForm.vue?vue&type=custom&index=0&blockType=div&class=vs-list--slot%20cursor&style=color%3A%20green&%40click=addThis(listItem)"
if (typeof block0 === 'function') block0(component)
import block1 from "./AlertMappingForm.vue?vue&type=custom&index=1&blockType=vs-col&vs-justify=center&vs-align=center&vs-lg=6&vs-sm=6&vs-xs=12"
if (typeof block1 === 'function') block1(component)
import block2 from "./AlertMappingForm.vue?vue&type=custom&index=2&blockType=vs-divider"
if (typeof block2 === 'function') block2(component)
import block3 from "./AlertMappingForm.vue?vue&type=custom&index=3&blockType=div&class=vx-row"
if (typeof block3 === 'function') block3(component)

export default component.exports